import React, { useRef, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Row, Col, Card, Descriptions } from 'antd';

import { companyType as companyTypeConstant } from '~constants/landlord';
import BusinessInfoModal from './modal';
import useStyles from '../../style';
import cardStyles from '../vetting-document/style';

const BusinessInfo = ({
  landlord = {},
  updateLandlordLoading = false,
  getLandlord,
  updateLandlord,
}) => {
  const classes = useStyles();
  const cardClasses = cardStyles();
  const { t } = useTranslation();
  const modalRef = useRef(null);

  const handleOpenModal = () => {
    modalRef.current?.handleOpenModal();
  };

  const landlordInfoLabels = useMemo(
    () => ({
      companyName: {
        transLabel: t('company_name'),
        value: landlord?.name,
      },
      companyType: {
        transLabel: t('cms.landlord.detail.company_type.label'),
        value: t(
          `cms.landlord.detail.company_type.${companyTypeConstant[
            landlord?.companyType
          ].toLowerCase()}`,
        ),
      },
      businessOpportunity: {
        transLabel: t('business_opportunity'),
        value: landlord?.businessScale,
      },
      registeredBusinessNumber: {
        transLabel: t('registered_business_number'),
        city: {
          transLabel: t('city'),
          value: ''.concat(landlord?.billingCity?.name, ', ', landlord?.billingCountry?.name),
        },
        registeredBusinessNumber: {
          transLabel: t('registered_business_number'),
          value: landlord?.businessNumber,
        },
        zipCode: {
          transLabel: t('zip_code'),
          value: landlord?.billingPostalCode,
        },
        address: {
          transLabel: t('registered_business_address'),
          value: landlord?.billingAddress,
        },
      },
      // zipCode: {
      //   transLabel: t('zip_code'),
      //   value: landlord?.billingPostalCode,
      // },
      // address: {
      //   transLabel: t('registered_business_address'),
      //   value: landlord?.billingAddress,
      // },
      // city: {
      //   transLabel: t('city'),
      //   value: ''.concat(landlord?.billingCity?.name, ', ', landlord?.billingCountry?.name),
      // },
    }),
    [t, landlord],
  );
  const personalInfoLabels = useMemo(
    () => ({
      companyName: {
        transLabel: t('cms.landlord_detail.individual.bussiness_info.name'),
        value: `${landlord?.firstName} ${landlord?.lastName}`,
      },
      bussinessType: {
        transLabel: t('cms.landlord_detail.individual.bussiness_info.bussiness_type'),
        value: landlord?.businessType === 'INDIVIDUAL' ? 'Individual' : 'Company',
      },
      businessOpportunity: {
        transLabel: t('business_opportunity'),
        value: landlord?.businessScale,
      },
      governmentIssuedID: {
        transLabel: t('cms.landlord_detail.individual.bussiness_info.government-issued_id'),
        value: landlord?.governmentIssuedId,
      },
      city: {
        transLabel: t('city'),
        value: ''.concat(landlord?.billingCity?.name, ', ', landlord?.billingCountry?.name),
      },
      address: {
        transLabel: t('cms.landlord_detail.individual.bussiness_info.address'),
        value: landlord?.billingAddress,
      },
      zipCode: {
        transLabel: t('zip_code'),
        value: landlord?.billingPostalCode,
      },
    }),
    [
      t,
      landlord?.firstName,
      landlord?.lastName,
      landlord?.businessType,
      landlord?.businessScale,
      landlord?.governmentIssuedId,
      landlord?.billingPostalCode,
      landlord?.billingAddress,
      landlord?.billingCity?.name,
      landlord?.billingCountry?.name,
      landlord?.billingPostalCode,
    ],
  );
  const showLabel = landlord?.businessType === 'COMPANY' ? landlordInfoLabels : personalInfoLabels;

  return (
    <Row>
      <Col span={24}>
        <Card
          title={t('cms.landlord.verification.business_info')}
          bordered={false}
          className={cardClasses.cardWrapper}
        >
          <For each="label" of={Object.keys(showLabel)}>
            <Card
              bordered={false}
              title={showLabel[label]?.transLabel}
              key={label.type}
              className={cardClasses.tableCard}
              extra={<div onClick={handleOpenModal}>{t('cms.sepcial_offer.edit.btn')}</div>}
            >
              <If condition={label === 'registeredBusinessNumber'}>
                <For each="subLabel" of={Object.keys(showLabel['registeredBusinessNumber'])}>
                  <If condition={showLabel['registeredBusinessNumber'][subLabel]?.transLabel}>
                    <Descriptions column={1} className={classes.descriptionWrapper}>
                      <Descriptions.Item
                        key={subLabel}
                        label={showLabel['registeredBusinessNumber'][subLabel]?.transLabel}
                      >
                        {showLabel['registeredBusinessNumber'][subLabel]?.value ?? '-'}
                      </Descriptions.Item>
                    </Descriptions>
                  </If>
                </For>
              </If>
              <If condition={label !== 'registeredBusinessNumber'}>
                <span>{showLabel[label]?.value ?? '-'}</span>
              </If>
            </Card>
          </For>
        </Card>
      </Col>

      <Col span={24}>
        <BusinessInfoModal
          wrappedComponentRef={form => (modalRef.current = form)}
          landlord={landlord}
          updateLandlordLoading={updateLandlordLoading}
          getLandlord={getLandlord}
          updateLandlord={updateLandlord}
        />
      </Col>
    </Row>
  );
};

BusinessInfo.propTypes = {
  landlord: PropTypes.object.isRequired,
  updateLandlordLoading: PropTypes.bool.isRequired,
  getLandlord: PropTypes.func.isRequired,
  updateLandlord: PropTypes.func.isRequired,
};

export default BusinessInfo;
